var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDentitionType2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_22315",
    "data-name": "Group 22315",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 211.309,
    height: 106.893,
    viewBox: "0 0 211.309 106.893",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1132",
    "data-name": "Rectangle 1132",
    width: 211.309,
    height: 106.893,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3217",
    "data-name": "Group 3217",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3791",
    "data-name": "Path 3791",
    d: "M206.37,106.842l1.394-16.195A11.768,11.768,0,0,0,197.417,78.13c-25.54-3-90.542,17.8-197.265-10.324",
    fill: "none",
    stroke: "#36393a",
    strokeWidth: 1.195
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3792",
    "data-name": "Path 3792",
    d: "M200.587.118l4.494,22.216A11.769,11.769,0,0,1,196.155,35.9C171.094,41.664,103.97,53.47,8.038,42.834",
    fill: "none",
    stroke: "#36393a",
    strokeWidth: 1.195
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3793",
    "data-name": "Path 3793",
    d: "M194.416,76.247s1.7,5.008,3.141,5.178,4.82-13.78,5.178-15.874a21.841,21.841,0,0,0,0-6.026l-11.12,3.225Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3794",
    "data-name": "Path 3794",
    d: "M194.416,76.247s1.7,5.008,3.141,5.178,4.82-13.78,5.178-15.874a21.841,21.841,0,0,0,0-6.026l-11.12,3.225Z",
    fill: "none",
    stroke: "#36393a",
    strokeWidth: 1.195
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3795",
    "data-name": "Path 3795",
    d: "M189.068,76.247s2.377,7.385,3.565,7.64,3.041-6.95,3.481-9.083c.428-2.084,3.625-13.468,3.455-15.59s-11.435,5.234-11.435,5.234Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3796",
    "data-name": "Path 3796",
    d: "M189.068,76.247s2.377,7.385,3.565,7.64,3.041-6.95,3.481-9.083c.428-2.084,3.625-13.468,3.455-15.59s-11.435,5.234-11.435,5.234Z",
    fill: "none",
    stroke: "#36393a",
    strokeWidth: 1.195
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3797",
    "data-name": "Path 3797",
    d: "M179.391,73.361s.34,12.648,6.621,12.478c1.789-.194,2.8,0,8.658-24.532l-12.138-1.358Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3798",
    "data-name": "Path 3798",
    d: "M179.391,73.361s.34,12.648,6.621,12.478c1.789-.194,2.8,0,8.658-24.532l-12.138-1.358Z",
    fill: "none",
    stroke: "#36393a",
    strokeWidth: 1.195
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3799",
    "data-name": "Path 3799",
    d: "M162.5,68.947s5.331,13.468,7.046,15.534c1.311,1.581,2.876,2.407,3.9,2.322s4.338-3,5.612-8.009,3.48-18.081,3.48-18.081l-20.542.679Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3800",
    "data-name": "Path 3800",
    d: "M162.5,68.947s5.331,13.468,7.046,15.534c1.311,1.581,2.876,2.407,3.9,2.322s4.338-3,5.612-8.009,3.48-18.081,3.48-18.081l-20.542.679Z",
    fill: "none",
    stroke: "#36393a",
    strokeWidth: 1.195
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3801",
    "data-name": "Path 3801",
    d: "M142.927,67.481s2.716,10.611,3.9,13.751a10.242,10.242,0,0,0,4.5,5.773c2.207,1.528,6.536,3.82,9.082,3.225s3.6-3.443,3.99-4.923c.458-1.748,3.735-20.542,2.971-23.259s-5.772-5.517-5.772-5.517Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3802",
    "data-name": "Path 3802",
    d: "M142.927,67.481s2.716,10.611,3.9,13.751a10.242,10.242,0,0,0,4.5,5.773c2.207,1.528,6.536,3.82,9.082,3.225s3.6-3.443,3.99-4.923c.458-1.748,3.735-20.542,2.971-23.259s-5.772-5.517-5.772-5.517Z",
    fill: "none",
    stroke: "#36393a",
    strokeWidth: 1.195
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3803",
    "data-name": "Path 3803",
    d: "M119.4,64.715s2.524,10.641,3.84,14.59,3.291,9.216,7.569,9.983,7.679-.548,8.338-3.839,5.705-17.333,5.485-19.308-3.435-5.483-5.411-6.909-6.108-3.951-9.727-3.842S119.4,64.715,119.4,64.715",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3804",
    "data-name": "Path 3804",
    d: "M119.4,64.715s2.524,10.641,3.84,14.59,3.291,9.216,7.569,9.983,7.679-.548,8.338-3.839,5.705-17.333,5.485-19.308-3.435-5.483-5.411-6.909-6.108-3.951-9.727-3.842S119.4,64.715,119.4,64.715Z",
    fill: "none",
    stroke: "#36393a",
    strokeWidth: 1.195
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3805",
    "data-name": "Path 3805",
    d: "M59.484,63.361s.687,9.538,2.1,12.937c1.3,3.111,4.366,6.421,8.118,7.24,3.689.805,16.955.805,20.287-2.653a15.659,15.659,0,0,0,4.4-8.047c.627-2.279,2.738-8.279,1.751-10.363S86.16,56.661,81.772,56.88s-22.288,6.481-22.288,6.481",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3806",
    "data-name": "Path 3806",
    d: "M59.484,63.361s.687,9.538,2.1,12.937c1.3,3.111,4.366,6.421,8.118,7.24,3.689.805,16.955.805,20.287-2.653a15.659,15.659,0,0,0,4.4-8.047c.627-2.279,2.738-8.279,1.751-10.363S86.16,56.661,81.772,56.88,59.484,63.361,59.484,63.361Z",
    fill: "none",
    stroke: "#36393a",
    strokeWidth: 1.195
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3807",
    "data-name": "Path 3807",
    d: "M96.263,63.805s1.593,7.208,3.254,12.4,2.906,10.276,7.992,10.172,7.163-2.387,8.1-6.332,2.7-8.2,3.321-10.587,1.142-7.474.312-8.615-11.418-4.464-11.418-4.464Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3808",
    "data-name": "Path 3808",
    d: "M96.263,63.805s1.593,7.208,3.254,12.4,2.906,10.276,7.992,10.172,7.163-2.387,8.1-6.332,2.7-8.2,3.321-10.587,1.142-7.474.312-8.615-11.418-4.464-11.418-4.464Z",
    fill: "none",
    stroke: "#36393a",
    strokeWidth: 1.195
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3809",
    "data-name": "Path 3809",
    d: "M26.235,60.327a69.311,69.311,0,0,0-.768,9.215c.137,1.928,1.945,5.84,4.041,8.23C32.48,81.161,41.753,83.2,48.226,82.1S60.353,67.9,60.353,67.348s-2.743-6.582-3.4-6.911a62.305,62.305,0,0,0-6.692-1.865c-.439,0-24.025,1.755-24.025,1.755",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3810",
    "data-name": "Path 3810",
    d: "M26.235,60.327a69.311,69.311,0,0,0-.768,9.215c.137,1.928,1.945,5.84,4.041,8.23C32.48,81.161,41.753,83.2,48.226,82.1S60.353,67.9,60.353,67.348s-2.743-6.582-3.4-6.911a62.305,62.305,0,0,0-6.692-1.865C49.821,58.572,26.235,60.327,26.235,60.327Z",
    fill: "none",
    stroke: "#36393a",
    strokeWidth: 1.195
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3811",
    "data-name": "Path 3811",
    d: "M191.573,33.054s0-9.36,1.82-10.661,18.071,16.771,17.291,33.412c0,0,0,3.64-4.42,3.9a22.657,22.657,0,0,0-6.371,1.04Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3812",
    "data-name": "Path 3812",
    d: "M191.573,33.054s0-9.36,1.82-10.661,18.071,16.771,17.291,33.412c0,0,0,3.64-4.42,3.9a22.657,22.657,0,0,0-6.371,1.04Z",
    fill: "none",
    stroke: "#36393a",
    strokeWidth: 1.195
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3813",
    "data-name": "Path 3813",
    d: "M22.4,52.367s1.323-12.1,11.342-12.1,13.421,2.647,16.634,5.482S54.909,58.6,54.531,59.172s-5.127,6.647-10.964,6.8c-3.023.082-7-4.8-8.886-4.881-3.473-.139-2.233,4.452-6.992,4.125-3.426-.236-6.238-5.482-5.293-12.854",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3814",
    "data-name": "Path 3814",
    d: "M22.4,52.367s1.323-12.1,11.342-12.1,13.421,2.647,16.634,5.482S54.909,58.6,54.531,59.172s-5.127,6.647-10.964,6.8c-3.023.082-7-4.8-8.886-4.881-3.473-.139-2.233,4.452-6.992,4.125C24.263,64.985,21.451,59.739,22.4,52.367Z",
    fill: "none",
    stroke: "#36393a",
    strokeWidth: 1.195
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3815",
    "data-name": "Path 3815",
    d: "M85.088,49.1S78.9,38.512,74.827,37.345a16.7,16.7,0,0,0-14.3,2.99c-4.941,4.03-7.281,14.95-5.331,21.061s7.539,6.752,8.581,6.5c3.792-.917,4.284-5.628,6.347-5.923,4.015-.573,5.423,2.972,9.8,2.242,2.44-.406,9.072-7.759,8.162-9.71s-3-5.41-3-5.41",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3816",
    "data-name": "Path 3816",
    d: "M85.088,49.1S78.9,38.512,74.827,37.345a16.7,16.7,0,0,0-14.3,2.99c-4.941,4.03-7.281,14.95-5.331,21.061s7.539,6.752,8.581,6.5c3.792-.917,4.284-5.628,6.347-5.923,4.015-.573,5.423,2.972,9.8,2.242,2.44-.406,9.072-7.759,8.162-9.71S85.088,49.1,85.088,49.1Z",
    fill: "none",
    stroke: "#36393a",
    strokeWidth: 1.195
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3817",
    "data-name": "Path 3817",
    d: "M88.088,45.4s-2.86,13-1.04,15.471,4.68,4.94,8.06,4.68,8.295-2.98,9.324-3.843c1.259-1.058,3.807-3.827,3.937-6.557s-1.82-6.371-2.73-8.451-3.257-11.656-10.271-11.961c-5.98-.26-7.28,10.661-7.28,10.661",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3818",
    "data-name": "Path 3818",
    d: "M88.088,45.4s-2.86,13-1.04,15.471,4.68,4.94,8.06,4.68,8.295-2.98,9.324-3.843c1.259-1.058,3.807-3.827,3.937-6.557s-1.82-6.371-2.73-8.451-3.257-11.656-10.271-11.961C89.388,34.484,88.088,45.4,88.088,45.4Z",
    fill: "none",
    stroke: "#36393a",
    strokeWidth: 1.195
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3819",
    "data-name": "Path 3819",
    d: "M109.669,43.845s-3.12,13.781.26,15.991,9.621,5.72,11.831,5.33,8.32-7.8,9.88-8.84a3.031,3.031,0,0,0,1.56-2.991c0-.91-4.03-7.8-5.07-11.96S123.97,29.8,117.209,30.324s-7.54,13.521-7.54,13.521",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3820",
    "data-name": "Path 3820",
    d: "M109.669,43.845s-3.12,13.781.26,15.991,9.621,5.72,11.831,5.33,8.32-7.8,9.88-8.84a3.031,3.031,0,0,0,1.56-2.991c0-.91-4.03-7.8-5.07-11.96S123.97,29.8,117.209,30.324,109.669,43.845,109.669,43.845Z",
    fill: "none",
    stroke: "#36393a",
    strokeWidth: 1.195
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3821",
    "data-name": "Path 3821",
    d: "M177.532,47.225s.312-10.782.78-13.651c.648-3.978,2.86-9.23,5.59-9.36s9.9,5.694,19.5,30.421c0,0,2.6,5.981-1.69,6.891-3.278.695-9.442,1.391-12.167,1.68a9.344,9.344,0,0,1-3.44-.262c-1.87-.511-4.449-1.632-5.324-4.018-1.43-3.9-3.25-11.7-3.25-11.7",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3822",
    "data-name": "Path 3822",
    d: "M177.532,47.225s.312-10.782.78-13.651c.648-3.978,2.86-9.23,5.59-9.36s9.9,5.694,19.5,30.421c0,0,2.6,5.981-1.69,6.891-3.278.695-9.442,1.391-12.167,1.68a9.344,9.344,0,0,1-3.44-.262c-1.87-.511-4.449-1.632-5.324-4.018C179.352,55.025,177.532,47.225,177.532,47.225Z",
    fill: "none",
    stroke: "#36393a",
    strokeWidth: 1.195
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3823",
    "data-name": "Path 3823",
    d: "M160.242,37.085s3.25-12.351,8.58-11.571c2.86.65,4.94,5.591,6.63,10.791s8.711,21.191,8.06,24.181-5.2,3.25-5.2,3.25l-7.614.644a9.255,9.255,0,0,1-3.842-.488c-1.714-.6-3.948-1.678-4.925-3.406a50.951,50.951,0,0,1-3.64-8.32,50.878,50.878,0,0,1,1.95-15.081",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3824",
    "data-name": "Path 3824",
    d: "M160.242,37.085s3.25-12.351,8.58-11.571c2.86.65,4.94,5.591,6.63,10.791s8.711,21.191,8.06,24.181-5.2,3.25-5.2,3.25l-7.614.644a9.255,9.255,0,0,1-3.842-.488c-1.714-.6-3.948-1.678-4.925-3.406a50.951,50.951,0,0,1-3.64-8.32A50.878,50.878,0,0,1,160.242,37.085Z",
    fill: "none",
    stroke: "#36393a",
    strokeWidth: 1.195
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3825",
    "data-name": "Path 3825",
    d: "M133.713,36.175c0,.65.65,6.89.26,9.49-.232,1.549-2.86,6.891-.13,10.4s7.15,10.661,16.121,9.491,11.3-8.484,11.44-11.051c.13-2.6-2.02-12.261-3.77-16.511-1.82-4.42-8.06-13.781-15.991-12.741s-7.93,10.921-7.93,10.921",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3826",
    "data-name": "Path 3826",
    d: "M133.713,36.175c0,.65.65,6.89.26,9.49-.232,1.549-2.86,6.891-.13,10.4s7.15,10.661,16.121,9.491,11.3-8.484,11.44-11.051c.13-2.6-2.02-12.261-3.77-16.511-1.82-4.42-8.06-13.781-15.991-12.741S133.713,36.175,133.713,36.175Z",
    fill: "none",
    stroke: "#36393a",
    strokeWidth: 1.195
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDentitionType2);
export default __webpack_public_path__ + "static/media/dentition_type_2.2050f29119fecc4c8e9ad73d136047fc.svg";
export { ForwardRef as ReactComponent };